<script lang="ts" setup>
  import ConsultationChat from '@/components/consultations/ConsultationChat.vue'

  definePage({
    meta: {
      authenticated: true,
      mustBeSubscribed: true,
      layout: 'blank',
    },
  })

  const consultationStore = useConsultationsStore()

  if (consultationStore.currentConsultation === null) {
    await consultationStore.activateLastConsultation()
  }
</script>

<template>
  <consultation-chat />
</template>
